var generateKey=function(){return Math.random().toString(36).substr(2,9)};export{generateKey};
//# sourceMappingURL=generateKey.js.map
